/**
 * The duration of the day in milliseconds.
 */
export var MS_PER_DAY = 86400000;
